


























































































































































































































import { Contact } from '@/modules/CDP/shared/contacts/domain/Contact'
import KeybeIcon from '../../icons/KeybeIcon.vue'
import { KeybeIconType } from '@/shared/infrastructure/enums/icons/KeybeIconType'
import EmitToast from '@/utils/EmitToast'
import { dataToHangUpCall, dataToStartCall } from '@/modules/Config/Channels/shared/domain/ChannelsController'
import { mapState } from 'vuex'
import ChannelsUseCases from '@/modules/Config/Channels/shared/application/ChannelsUseCases'
import ChannelsController from '@/modules/Config/Channels/shared/infrastructure/controllers/Channels.controller'
import SubscriptionAcceptCall from '../../../graphql/subscriptions/subscription-accept-call.graphql'
import SubscriptionConnectCall from '../../../graphql/subscriptions/subscription-connect-call.graphql'
import SubscriptionDisconnectCall from '../../../graphql/subscriptions/subscription-disconnect-call.graphql'
import SubscriptionRejectCall from '../../../graphql/subscriptions/subscription-reject-call.graphql'
import WhatsAppCallsApolloProvider from '../../../graphql/WhatsAppCallsApolloProvider'
import AnimatedAudioBars from '../AnimatedAudioBars/AnimatedAudioBars.vue'
export default {
  components: {
    KeybeIcon,
    AnimatedAudioBars
  },
  props: {
    contact: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('UserStore', ['token', 'user']),
    ...mapState('AppStore', ['selectedApp']),
    ...mapState('ConversationStore', ['selectedRoom']),
    callStatus (): string {
      return this.status
    },
    contactComputed (): Contact {
      return this.contact
    },
    contactPhoto (): string {
      if (this.contactComputed?.photo) {
        return this.contactComputed.photo || ''
      }
      return ''
    },
    callerPhoto (): string {
      if (this.user?.photo) {
        return this.user.photo || ''
      }
      return ''
    },
    contactName (): string {
      if (this.contactComputed?.name && this.contactComputed?.surname) {
        return `${this.contactComputed.name} ${this.contactComputed.surname}`
      } else if (this.contactComputed?.name) {
        return this.contactComputed.name
      }
      return ''
    },
    contactPhone (): string {
      if (this.contactComputed?.phone && this.contactComputed?.phone?.length > 0) {
        const firstPhone = this.contactComputed.phone[0]
        return firstPhone.value || ''
      }
      return ''
    }
  },
  mounted () {
    this.callStatus = ''
    this.getMicrophonePermissions()
  },
  data () {
    return {
      channelsController: new ChannelsController(),
      KeybeIconType,
      microphone: true,
      status: 'ringing_call',
      peerConnection: null,
      localSDP: '',
      stream: null,
      loadingHangUp: false,
      callId: '',
      callDuration: '',
      acceptCallSubscription: null,
      connectCallSubscription: null,
      disconnectCallSubscription: null,
      rejectCallSubscription: null,
      dialToneAudio: null,
      whatsAppCallsApolloClient: WhatsAppCallsApolloProvider.getInstance().provider.defaultClient,
      audioContext: null,
      analyser: null,
      dataArray: null,
      dataArrayUser: null,
      callTimer: null,
      callerAudio: null,
      isCallerTalking: false,
      isUserTalking: false,
      userAudioCheckInterval: null,
      userAnalyser: null,
      minimize: false
    }
  },
  methods: {
    async hangUpCall (): Promise<void> {
      this.loadingHangUp = true
      const data: dataToHangUpCall = {
        token: this.token,
        data: {
          action: 'terminateCall',
          payload: {
            userHost: this.selectedRoom?.userHost || '',
            callId: this.callId || ''
          }
        }
      }
      const response = await ChannelsUseCases.hangUpCall(this.channelsController, data)
      if (response.status) {
        this.status = 'terminated_call'
        this.stopCallTimer()
      }
      this.loadingHangUp = false
    },
    toggleMicrophone () {
      this.microphone = !this.microphone
      if (this.stream && this.stream.getAudioTracks().length > 0) {
        this.stream.getAudioTracks().forEach(track => {
          track.enabled = this.microphone
        })
      }
    },
    async getMicrophonePermissions () {
      this.status = 'requestingPermissions_call'
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        this.microphone = true
        this.detectCallerAudio()
        this.startCall()
      } catch (err) {
        EmitToast.emitErrors(this.$t('noMicrophonePermissions'))
        this.microphone = false
        this.status = 'permissionsRejected_call'
      }
    },
    detectCallerAudio () {
      if (this.stream && this.stream.getAudioTracks().length > 0) {
        this.callerAudio = this.stream.getAudioTracks()[0]
        try {
          if (!this.audioContext) {
          // @ts-ignore
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
          }
          // clean previous analyser if any
          if (this.analyser) {
            try { this.analyser.disconnect() } catch (e) {}
            this.analyser = null
          }
          const source = this.audioContext.createMediaStreamSource(this.stream)
          this.analyser = this.audioContext.createAnalyser()
          this.analyser.fftSize = 2048
          source.connect(this.analyser)
          this.dataArray = new Uint8Array(this.analyser.fftSize)
          const threshold = 0.02 // adjust sensitivity as needed

          // clear previous interval if present
          if (this.audioCheckInterval) {
            clearInterval(this.audioCheckInterval)
            this.audioCheckInterval = null
          }

          // periodically check audio level and set isCallerTalking to true/false
          this.isCallerTalking = false
          this.audioCheckInterval = setInterval(() => {
            if (!this.analyser || !this.dataArray) {
              this.isCallerTalking = false
              return
            }
            this.analyser.getByteTimeDomainData(this.dataArray)
            let sum = 0
            for (let i = 0; i < this.dataArray.length; i++) {
              const v = (this.dataArray[i] - 128) / 128 // normalize -1..1
              sum += v * v
            }
            const rms = Math.sqrt(sum / this.dataArray.length)
            this.isCallerTalking = rms > threshold
          }, 250)
        } catch (err) {
          console.warn('detectCallerAudio error:', err)
          this.isCallerTalking = false
        }
      } else {
        this.callerAudio = null
        this.isCallerTalking = false
        if (this.audioCheckInterval) {
          clearInterval(this.audioCheckInterval)
          this.audioCheckInterval = null
        }
        if (this.analyser) {
          try { this.analyser.disconnect() } catch (e) {}
          this.analyser = null
        }
      }
    },
    playRingSound () {
      try {
        // start dial tone in a loop
        const dialToneSrc = require('@/assets/dial_tone.mp3')
        const dialTone = new Audio(dialToneSrc)
        dialTone.loop = true
        dialTone.play().catch((err: any) => {
          // autoplay may be blocked by browser; ignore for now
          console.warn('Dial tone play blocked:', err)
        })
        this.dialToneAudio = dialTone
      } catch (err) {
        console.warn('Failed to load/play dial tone:', err)
      }
    },
    async startCall () {
      this.callId = ''
      this.status = 'starting_call'
      const config = {
        iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]
      }
      this.peerConnection = new RTCPeerConnection(config)
      this.playRingSound()
      // Si se obtuvo el stream, agrega el track de audio real
      if (this.stream && this.stream.getAudioTracks().length > 0) {
        this.stream.getAudioTracks().forEach(track => {
          this.peerConnection.addTrack(track, this.stream)
        })
      } else {
        // Si no hay permisos, agrega un track vacío para generar SDP correctamente
        const silentStream = new MediaStream()
        try {
          // create an empty oscillator-based track as a fallback (some browsers won't accept a naked MediaStreamTrack())
          // but we keep it guarded in try/catch
          // @ts-ignore
          const ctx = new (window.AudioContext || window.webkitAudioContext)()
          const oscillator = ctx.createOscillator()
          const dst = ctx.createMediaStreamDestination()
          oscillator.connect(dst)
          oscillator.start()
          const dummyTrack = dst.stream.getAudioTracks()[0]
          if (dummyTrack) {
            this.peerConnection.addTrack(dummyTrack, silentStream)
          }
        } catch (e) {
          console.warn('No se pudo agregar track vacío:', e)
        }
      }

      // Escucha candidatos ICE (opcional)
      this.peerConnection.onicecandidate = event => {
        if (event.candidate) {
        }
      }

      // Crea y guarda la oferta SDP
      const offer = await this.peerConnection.createOffer()
      await this.peerConnection.setLocalDescription(offer)
      this.localSDP = offer.sdp

      // Envía la oferta al endpoint
      this.sendSDPToServer(offer.sdp)
    },
    async sendSDPToServer (sdp) {
      const data: dataToStartCall = {
        token: this.token,
        data: {
          to: this.selectedRoom?.userGuest || '',
          from: this.selectedRoom?.userHost || '',
          sdp: sdp,
          appUUID: this.selectedApp?.uuid || ''
        }
      }
      const response = await ChannelsUseCases.startCall(this.channelsController, data)
      if (response.status) {
        this.callId = response.callId || ''
        this.status = 'ringing_call'
        this.startSubscriptions()
      } else {
        EmitToast.emitErrors(this.$t('callStartError'))
      }
    },
    async startSubscriptions (): Promise<void> {
      this.acceptCallSubscription = this.whatsAppCallsApolloClient
        .subscribe({
          query: SubscriptionAcceptCall,
          variables: {
            appUUID: this.selectedApp?.uuid,
            callId: this.callId
          }
        })
        .subscribe((res) => {
          this.status = 'accepted_call'
          if (this.dialToneAudio) this.dialToneAudio.pause()
          this.startCallTimer()
          this.detectUserAudio()
          this.connectRTC(res)
        })
      this.disconnectCallSubscription = this.whatsAppCallsApolloClient
        .subscribe({
          query: SubscriptionDisconnectCall,
          variables: {
            appUUID: this.selectedApp?.uuid,
            callId: this.callId
          }
        })
        .subscribe((res) => {
          this.status = 'disconnected_call'
          this.stopCallTimer()
          this.isUserTalking = false
          if (this.dialToneAudio) this.dialToneAudio.pause()
        })
      this.rejectCallSubscription = this.whatsAppCallsApolloClient
        .subscribe({
          query: SubscriptionRejectCall,
          variables: {
            appUUID: this.selectedApp?.uuid,
            callId: this.callId
          }
        })
        .subscribe((res) => {
          this.status = 'rejected_call'
          this.stopCallTimer()
          this.isUserTalking = false
          if (this.dialToneAudio) this.dialToneAudio.pause()
        })
      this.connectCallSubscription = this.whatsAppCallsApolloClient
        .subscribe({
          query: SubscriptionConnectCall,
          variables: {
            appUUID: this.selectedApp?.uuid,
            callId: this.callId
          }
        })
        .subscribe((res) => {
          this.status = 'connected_call'
          this.isUserTalking = false
        })
    },
    detectUserAudio () {
      // reset state & clear previous resources
      this.isUserTalking = false

      if (this.userAudioCheckInterval) {
        clearInterval(this.userAudioCheckInterval)
        this.userAudioCheckInterval = null
      }
      if (this.userAnalyser) {
        try { this.userAnalyser.disconnect() } catch (e) {}
        this.userAnalyser = null
      }
      this.dataArrayUser = null

      if (!this.peerConnection) return

      const receivers = this.peerConnection.getReceivers()
      if (!receivers || receivers.length === 0) return

      for (const receiver of receivers) {
        const track = receiver.track
        if (!track || track.kind !== 'audio') continue

        try {
          if (!this.audioContext) {
          // @ts-ignore
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
          }

          // Create media stream from incoming track
          const incomingStream = new MediaStream([track])
          const source = this.audioContext.createMediaStreamSource(incomingStream)

          // create analyser
          this.userAnalyser = this.audioContext.createAnalyser()
          this.userAnalyser.fftSize = 2048
          source.connect(this.userAnalyser)

          // reuse existing dataArrayUser if size matches, otherwise recreate
          const bufSize = this.userAnalyser.fftSize
          if (!this.dataArrayUser || this.dataArrayUser.length !== bufSize) {
            this.dataArrayUser = new Uint8Array(bufSize)
          }

          const threshold = 0.02 // adjust sensitivity as needed
          this.isUserTalking = false

          // polling interval to check RMS of incoming audio
          this.userAudioCheckInterval = setInterval(() => {
            if (!this.userAnalyser || !this.dataArrayUser) {
              this.isUserTalking = false
              return
            }
            try {
              this.userAnalyser.getByteTimeDomainData(this.dataArrayUser)
              let sum = 0
              for (let i = 0; i < this.dataArrayUser.length; i++) {
                const v = (this.dataArrayUser[i] - 128) / 128
                sum += v * v
              }
              const rms = Math.sqrt(sum / this.dataArrayUser.length)
              this.isUserTalking = rms > threshold
            } catch (err) {
              console.warn('user audio check error:', err)
              this.isUserTalking = false
            }
          }, 250)

          // attach to first audio receiver only
          break
        } catch (err) {
          console.warn('detectUserAudio error:', err)
          this.isUserTalking = false
        }
      }
    },
    connectRTC (res) {
      // Attach remote audio stream to audio element for listening
      if (res?.data?.onAcceptCall?.sdpAnswer) {
        const remoteDesc = new RTCSessionDescription({
          type: 'answer',
          sdp: res.data.onAcceptCall.sdpAnswer
        })
        this.peerConnection.setRemoteDescription(remoteDesc)
      }
      // Listen for remote stream
      this.peerConnection.ontrack = (event) => {
        // @ts-expect-error error
        let audio: HTMLAudioElement | null = document.getElementById('remoteAudio') || null
        if (!audio) {
          audio = document.createElement('audio')
          audio.id = 'remoteAudio'
          audio.autoplay = true
          document.body.appendChild(audio)
        }
        audio.srcObject = event.streams[0]
      }
    },
    startCallTimer () {
      this.callDuration = '00:00'
      if (this.callTimer) {
        clearInterval(this.callTimer)
        this.callTimer = null
      }
      this.callTimer = setInterval(() => {
        const [minutes, seconds] = this.callDuration.split(':').map(Number)
        const totalSeconds = minutes * 60 + seconds + 1
        this.callDuration = `${String(Math.floor(totalSeconds / 60)).padStart(2, '0')}:${String(totalSeconds % 60).padStart(2, '0')}`
      }, 1000)
    },
    stopCallTimer () {
      if (this.callTimer) {
        clearInterval(this.callTimer)
        this.callTimer = null
      }
    }
  },
  beforeDestroy () {
    this.hangUpCall()
  }
}
